export default {
    install: function (Vue) {
        Vue.filter('toFixed', function (value, length = 2) {            
            return Number(value).toFixed(length)
        })
    }
}


// WEBPACK FOOTER //
// ./src/filter/toFixed.js